module.exports = __webpack_public_path__ + "35e33aa7768845bf0e240c3f98e6c4a1.svg";